import React from 'react';
import { styled } from '@linaria/react';
import { QRCodeSVG } from 'qrcode.react';
import { COLORS, typographyStyles } from '@livecommerce/design-system';
import { isDev, isEmulator, isStage, projectId, projectIdWithEnv } from 'constants/gcp.js';
import config from '../../../../client-config.js';

const { getBodyText } = typographyStyles;

const Container = styled.section`
  overflow: auto;
  height: 100%;
`;

const Headline = styled.h2`
  margin: 0;
  ${getBodyText(14, 500)};
`;

const QRCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
`;

const DevIndicatorList = styled.ol`
  padding: 0;
  list-style-position: inside;
  ${getBodyText(14, 400)};
  color: ${COLORS.dark_500};

  > li {
    margin-top: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const DevIndicator = (props) => {
  const iOSDevModeUrl = 'livecommercedev://?devmode=true';
  const iOSSelectProjectUrl = isEmulator && config.lanClientConfig
    ? `livecommercedev://?${Object.entries({ project: projectId, emulatorsConfig: JSON.stringify(config.lanClientConfig) }).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')}`
    : `livecommercedev://?project=${encodeURIComponent(projectId)}`;
  const testflightLink = 'https://apps.apple.com/us/app/testflight/id899247664';
  return (
    <Container {...props}>
      <Headline>{projectIdWithEnv()}</Headline>
      <DevIndicatorList>
        {isDev && (
          <li>
            Ensure this organization was created with media capabilities: applicationId must be set in{' '}
            <i>/organizations/:orgId/settings/media</i> and a webhook subscription must be configured.
          </li>
        )}
        <li>
          Ask for a TestFlight invite, download the{' '}
          <a target="_blank" href={testflightLink} rel="noreferrer">
            TestFlight app
          </a>{' '}
          and install "Bambuser Linoleum" (DEV badge in the app icon)
        </li>
        {isDev && (
          <>
            <li>
              To target projects other than Linoleum, enable dev mode <a href={iOSDevModeUrl}>{iOSDevModeUrl}</a>
              <QRCodeWrapper>
                <QRCodeSVG value={iOSDevModeUrl} />
              </QRCodeWrapper>
            </li>
            <li>
              Select this Firebase project <a href={iOSSelectProjectUrl}>{iOSSelectProjectUrl}</a>
              <QRCodeWrapper>
                <QRCodeSVG value={iOSSelectProjectUrl} />
              </QRCodeWrapper>
            </li>
          </>
        )}
        {isStage && (
          <li>
            Optional: If your TestFlight install was previously targeting another environment, you can reset it back to
            Linoleum using this link <a href={iOSSelectProjectUrl}>{iOSSelectProjectUrl}</a>
            <QRCodeWrapper>
              <QRCodeSVG value={iOSSelectProjectUrl} />
            </QRCodeWrapper>
          </li>
        )}
        {isEmulator && (
          <li>
            Select this Firebase emulator project <a href={iOSSelectProjectUrl}>{iOSSelectProjectUrl}</a>
            <QRCodeWrapper>
              <QRCodeSVG value={iOSSelectProjectUrl} />
            </QRCodeWrapper>
          </li>
        )}
      </DevIndicatorList>
    </Container>
  );
};

export default DevIndicator;
